import { render, staticRenderFns } from "./EditDialogFooter.vue?vue&type=template&id=31518d26&scoped=true&"
import script from "./EditDialogFooter.vue?vue&type=script&lang=js&"
export * from "./EditDialogFooter.vue?vue&type=script&lang=js&"
import style0 from "./EditDialogFooter.vue?vue&type=style&index=0&id=31518d26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31518d26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31518d26')) {
      api.createRecord('31518d26', component.options)
    } else {
      api.reload('31518d26', component.options)
    }
    module.hot.accept("./EditDialogFooter.vue?vue&type=template&id=31518d26&scoped=true&", function () {
      api.rerender('31518d26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/dialog/EditDialogFooter.vue"
export default component.exports